<template>
  <router-view />
  <Toast position="top-right" />
</template>
<script>
import { defineComponent } from 'vue';
import Toast from 'primevue/toast';
import { useToast } from 'primevue/usetoast';
import { setToastHandler } from 'src/helpers/notify';
// LocalStorage replaced with native localStorage
import axios from 'axios';
import 'vue-search-select/dist/VueSearchSelect.css';
import { safeGetString, safeSetItem } from 'src/helpers/localStorage';

export default defineComponent({
  name: 'App',
  components: { Toast },
  setup() {
    const toast = useToast();
    setToastHandler((opts) => toast.add(opts));
  },
  methods: {
    checkForNewVersion: async function () {
      try {
        const response = await axios.get('/version.txt?timestamp=' + new Date().getTime());
        const currentVersion = safeGetString('getVersion', '');
        if (currentVersion !== response?.data) {
          safeSetItem('getVersion', response?.data);
          location.reload();
        }
      } catch (error) {
        const currentVersion = safeGetString('getVersion', '');
        if (currentVersion !== 'get_version_failed') {
          safeSetItem('getVersion', 'get_version_failed');
        }
      }
      setTimeout(this.checkForNewVersion, 60000);
    },
  },
  mounted() {
    this.checkForNewVersion();
  },
});
</script>
<style lang="scss">
body {
  overflow-y: scroll;
}
</style>
